export enum ChangeRequestActionEventsEnum {
  APPROVE = 'APPROVE',
  REJECT = 'REJECT',
  _UNKOWN_ = '_UNKOWN_',
}
